import { render } from "./HorizontalItemScroll.vue?vue&type=template&id=0a08f7fd&scoped=true"
import script from "./HorizontalItemScroll.vue?vue&type=script&lang=js"
export * from "./HorizontalItemScroll.vue?vue&type=script&lang=js"

import "./HorizontalItemScroll.vue?vue&type=style&index=0&id=0a08f7fd&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a08f7fd"]])

export default __exports__